import React from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "../../../../../../../../ui/TextField";

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
  }
  });

const Purpose = ({
  classes,
  modulePurpose,
  disabled
}) => {
  return(
    <div className={classes.root}>
      <Typography className={classes.heading}>Цели реализации модуля</Typography>
      <TextField
        value={modulePurpose.data ? modulePurpose.data.purpose : null}
        label=""
        readOnly={true} hoverStateEnabled={false}
      />
    </div>
  );
}

export default withStyles(styles)(Purpose);
